var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",class:{link: _vm.link},style:(_vm.style),attrs:{"src":_vm.asset(_vm.logoPath, 'img')},on:{"click":_vm.navigate}})}
var staticRenderFns = []

export { render, staticRenderFns }